export default "__VITE_ASSET__BitJXAF4__"